import styled from "@emotion/styled";
import { black, darkGreen, lightGreen, StepNumberInput } from "@stepfinance/react";
import { Tag } from "antd";
import React, { useState } from "react";

import { useSlippageConfig } from "../../contexts/app/config";
import { useLanguageContext } from "../../contexts/language/language";
import { NumberLabel } from "../shared";

export const Slippage = () => {
  const { slippage, setSlippage } = useSlippageConfig();
  const [customSlippage, setCustomSlippage] = useState<string | number>(slippage);

  const {
    currentLanguageData: {
      pages: {
        swapLP: { settings: settingsText },
      },
    },
  } = useLanguageContext();

  const isSelected = (val: number) => {
    return val === slippage * 100;
  };

  const handleSlippageClick = (slippagePct: number) => {
    setSlippage(slippagePct / 100.0);
    setCustomSlippage(slippagePct);
  };

  return (
    <SlippageContainer>
      <SlippageInnerContainer>
        <SlippageHeader>{settingsText.selectSlippage}</SlippageHeader>
        <div>
          {[0.1, 0.5, 1.0].map((item) => {
            return (
              <SlippageButton
                key={item.toString()}
                onClick={() => handleSlippageClick(item)}
                isSelected={isSelected(item)}
              >
                <NumberLabel>{item}%</NumberLabel>
              </SlippageButton>
            );
          })}
        </div>
      </SlippageInnerContainer>
      <SlippageInnerContainer slippageInput>
        <SlippageHeader>{settingsText.orSetCustomSlippage}</SlippageHeader>
        <StepNumberInput
          value={String(customSlippage)}
          variant="filled"
          SuffixIcon={<span>%</span>}
          displayMinimizedVersion
          onChange={(event, rawValue) => {
            setCustomSlippage(event.currentTarget.value);
            setSlippage(Number(rawValue) / 100);
          }}
        />
      </SlippageInnerContainer>
    </SlippageContainer>
  );
};

const SlippageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const SlippageInnerContainer = styled.div<{ slippageInput?: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.slippageInput
      ? `
  max-width: 150px;
  `
      : ""};
`;

const SlippageHeader = styled.span`
  margin-bottom: 5px;
  font-size: 11px;
`;

const SlippageButton = styled(Tag)<{ isSelected: boolean }>`
  background: ${({ isSelected }) => (isSelected ? lightGreen : darkGreen)};
  color: ${({ isSelected }) => (isSelected ? black : lightGreen)};
  font-weight: 700;
  border: none;
  padding: 5px 15px;
  margin-right: 10px;
  border: ${({ isSelected }) => (isSelected ? `1px solid ${lightGreen}` : `1px solid ${darkGreen}`)};
  :hover {
    border: 1px solid ${lightGreen};
    cursor: pointer;
  }
`;
